"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAtLeastOneTableRowVisible = exports.isSpecialButtonsEnabled = exports.createQuestionModel = void 0;
const question_model_1 = __importDefault(require("@yandex-int/pythia-libs/lib/question-model"));
const questions_1 = require("src/types/questions");
// eslint-disable-next-line import/prefer-default-export, complexity, max-statements
function createQuestionModel(questions, questionId, { charLimits: { answerWithText, shortText, longText } = {}, prevState } = {}) {
    const question = questions[questionId];
    const questionModel = (0, question_model_1.default)(question, prevState);
    if ((0, questions_1.isTableQuestion)(question)) {
        const boundQuestionsRevision = {};
        question.boundQuestions.forEach(q => {
            boundQuestionsRevision[q] = questions[q];
        });
        question.boundQuestionsRevision = boundQuestionsRevision;
    }
    if ((0, questions_1.isQuestionWithOtherAnswerWithText)(question) && answerWithText)
        question.charLimit = answerWithText;
    if ((0, questions_1.isShortTextQuestion)(question) && shortText)
        question.charLimit = shortText;
    if ((0, questions_1.isLongTextQuestion)(question) && longText)
        question.charLimit = longText;
    return questionModel;
}
exports.createQuestionModel = createQuestionModel;
// eslint-disable-next-line complexity
function isSpecialButtonsEnabled(question, isTableBoundQuestion = false) {
    return (!isTableBoundQuestion &&
        question.type !== 'choice' &&
        ('otherAnswer' in question ||
            'otherAnswerWithText' in question ||
            'noAnswer' in question ||
            'noOpinionAnswer' in question));
}
exports.isSpecialButtonsEnabled = isSpecialButtonsEnabled;
function isAtLeastOneTableRowVisible(boundQuestionsRevision) {
    return Object.values(boundQuestionsRevision).some(question => question.visible !== false);
}
exports.isAtLeastOneTableRowVisible = isAtLeastOneTableRowVisible;
